import { render, staticRenderFns } from "./input-reorder-items.vue?vue&type=template&id=32a4827a&scoped=true&"
import script from "./input-reorder-items.vue?vue&type=script&lang=js&"
export * from "./input-reorder-items.vue?vue&type=script&lang=js&"
import style0 from "./input-reorder-items.vue?vue&type=style&index=0&id=32a4827a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4827a",
  null
  
)

export default component.exports